import { __decorate } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxMaskIonicModule } from 'ngx-mask-ionic';

let UiCAccountBalanceDevolutionComponent = class UiCAccountBalanceDevolutionComponent {
    constructor() {
        this.clickEvent = new EventEmitter();
    }
    ngOnInit() {
    }
    showBalance() {
        this.clickEvent.emit();
    }
};
__decorate([
    Input()
], UiCAccountBalanceDevolutionComponent.prototype, "textTitle", void 0);
__decorate([
    Input()
], UiCAccountBalanceDevolutionComponent.prototype, "iconName", void 0);
__decorate([
    Input()
], UiCAccountBalanceDevolutionComponent.prototype, "showBLC", void 0);
__decorate([
    Output()
], UiCAccountBalanceDevolutionComponent.prototype, "clickEvent", void 0);
UiCAccountBalanceDevolutionComponent = __decorate([
    Component({
        selector: 'ui-c-account-balance-devolution',
        template: "<ion-col class=\"balance\">\n  <ion-col class=\"showBalance border ion-padding\">\n    <ion-row>\n      <ion-row class=\"ion-no-padding\">\n        <h3 class=\"devolution-title ion-text ion-text-left\">\n          <span>\n            {{textTitle}}\n          </span>\n        </h3>\n      </ion-row>\n      <ion-row class=\"d-flex align-items-center\">\n        <ion-col class=\"ion-no-padding\">\n          <ng-container *ngIf=\"showBLC\">\n            <ng-content></ng-content>\n          </ng-container>\n          <ng-container *ngIf=\"!showBLC\">\n            <div class=\"blockBalance\"></div>\n          </ng-container>\n        </ion-col>\n        <ion-col class=\"ion-icon\">\n          <ion-button class=\"ion-no-margin\" (click)=\"showBalance()\" fill=\"clear\" color=\"dark\">\n            <ion-icon class=\"icon-size\" [name]=\"iconName\"></ion-icon>\n          </ion-button>\n        </ion-col>\n      </ion-row>\n    </ion-row>\n  </ion-col>\n</ion-col>\n"
    })
], UiCAccountBalanceDevolutionComponent);

let UiCAccountBalanceDevolutionModule = class UiCAccountBalanceDevolutionModule {
};
UiCAccountBalanceDevolutionModule = __decorate([
    NgModule({
        declarations: [UiCAccountBalanceDevolutionComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            NgxMaskIonicModule,
            IonicModule
        ],
        exports: [UiCAccountBalanceDevolutionComponent]
    })
], UiCAccountBalanceDevolutionModule);

/*
 * Public API Surface of ui-c-account-balance-devolution
 */

/**
 * Generated bundle index. Do not edit.
 */

export { UiCAccountBalanceDevolutionComponent, UiCAccountBalanceDevolutionModule };
//# sourceMappingURL=wlp-ui-c-account-balance-devolution.js.map
